import { NavSidebar } from "@/components/NavBarRework/components/app-sidebar"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { Outlet } from "react-router-dom"
import { ColoredTop } from "../misc"

export default function NavBarRework() {
  return (
    <SidebarProvider>
      <NavSidebar />

      <SidebarInset>
        <SidebarTrigger className="m-2 fixed" />
        <ColoredTop />
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
